module.exports = __webpack_public_path__ + "img/1587.405d3185.png";